export const demandMonitorGpuEndpointPath = '/api/v2/demand-monitor/gpu'
